export const getNiceWalletName = (address?: string, chainName?: string) => {
  if (!address || !chainName) {
    return '';
  }

  return `${chainName} Wallet ...${address.slice(-6)}`;
};
